"use client";

export default function PoliticaGDPRPage() {
  return (
    <section className="bg-[#FDF9F5] text-[#264653] py-20 px-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <h1 className="text-3xl font-bold mb-4">Politica de confidențialitate (GDPR)</h1>

        <p className="text-[#264653]/80">
          Această politică explică modul în care <strong>Zenyra Therapy SRL</strong> colectează,
          utilizează și protejează datele cu caracter personal ale utilizatorilor, în conformitate
          cu Regulamentul (UE) 2016/679 (GDPR).
        </p>

        <h2 className="text-xl font-semibold mt-8">1. Date colectate</h2>
        <p>Sunt colectate doar datele strict necesare: nume, e-mail, telefon (opțional) și informații privind sesiunile efectuate.</p>

        <h2 className="text-xl font-semibold mt-8">2. Scopul prelucrării</h2>
        <ul className="list-disc list-inside text-[#264653]/80">
          <li>Crearea și gestionarea contului de utilizator.</li>
          <li>Facilitarea comunicării cu terapeuții.</li>
          <li>Emiterea facturilor și gestionarea plăților.</li>
          <li>Transmiterea de notificări administrative și informații relevante.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">3. Temeiul legal</h2>
        <p>
          Datele sunt prelucrate în baza consimțământului tău, a obligațiilor legale și/sau a
          interesului legitim de a furniza serviciile solicitate.
        </p>

        <h2 className="text-xl font-semibold mt-8">4. Stocarea datelor</h2>
        <p>
          Datele tale sunt stocate în condiții de securitate, pe servere din UE, pentru o perioadă
          de maximum 5 ani de la ultima interacțiune.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. Drepturile tale</h2>
        <ul className="list-disc list-inside text-[#264653]/80">
          <li>Dreptul de acces și rectificare a datelor.</li>
          <li>Dreptul de ștergere (“dreptul de a fi uitat”).</li>
          <li>Dreptul de opoziție și portabilitate a datelor.</li>
          <li>Dreptul de a depune o plângere la ANSPDCP (www.dataprotection.ro).</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">6. Confidențialitate și securitate</h2>
        <p>
          Mindtale utilizează măsuri tehnice și organizatorice adecvate (criptare, acces restricționat,
          conexiuni HTTPS) pentru protecția datelor tale.
        </p>

        <h2 className="text-xl font-semibold mt-8">7. Transmiterea datelor</h2>
        <p>
          Datele nu sunt vândute sau transmise către terți, cu excepția partenerilor tehnici care
          asigură funcționarea platformei (hosting, procesare plăți) – toți fiind conformi GDPR.
        </p>

        <h2 className="text-xl font-semibold mt-8">8. Contact</h2>
        <p>
          Pentru orice întrebări legate de protecția datelor personale, ne poți contacta la{" "}
          <a href="mailto:hello@mindtale.ro" className="text-[#E76F51] hover:underline">
            hello@mindtale.ro
          </a>.
        </p>
      </div>
    </section>
  );
}
